import { render, staticRenderFns } from "./shetu.vue?vue&type=template&id=a0a079f6&scoped=true&"
import script from "./shetu.vue?vue&type=script&lang=ts&"
export * from "./shetu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a079f6",
  null
  
)

export default component.exports